import comp from "./GroupedList";
export default comp;
